export default __webpack_public_path__ + "media/images/flags/nm-e8e684cbcc6f1b61437aa35afdbd5938.png";